import script from "./VisitNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitNotification.vue?vue&type=script&setup=true&lang=js"

import "./VisitNotification.vue?vue&type=style&index=0&id=99037600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99037600"]])

export default __exports__